// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_reporting_ui_styles" + "." + "86a4b151" + ".chunk.css";
};